
import { Pagination, Box, useTheme } from '@mui/material';
import { tokens } from '../../theme/theme';


const CustomPagination = ({
  pageCount,
  currentPage,
  onPageChange,
  size = "medium",
  color = "primary",
  variant = "outlined",
  shape = "rounded",
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
  return (
    <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>     
      <Pagination
        count={pageCount}
        page={currentPage}
        onChange={onPageChange}
        size={size}
        color={color}
        variant={variant}
        shape={shape}
        showFirstButton
        showLastButton
        siblingCount={1}
        boundaryCount={1}
        sx={{
            '& .MuiPaginationItem-root': {
              fontWeight: 500,
              borderRadius: '12px',
              borderColor: colors.primary?.main || '#1976d2',
              '&.Mui-selected': {
                backgroundColor: colors.primary?.main || '#1976d2',
                color: '#fff',
                '&:hover': {
                  backgroundColor: colors.primary?.dark || '#1565c0',
                },
              },
            },
          }}
      />
      </Box>
    
  );
};

export default CustomPagination;
